module.exports = __webpack_public_path__ + "img/T922.abeab4ea.jpg";